import React, { DragEvent } from 'react'
import styled from 'styled-components'

export interface ShareListItemDragDataProps {
  shareId: string
}

const useShareListItemDrag = <T extends HTMLElement>(
  disabled: boolean,
  shareId: string
) => {
  if (disabled) {
    return {
      draggable: false,
    }
  }

  const onDragStart = (event: DragEvent<T>) => {
    event.stopPropagation()

    const stringifiedParameters = JSON.stringify({
      shareId,
    } as ShareListItemDragDataProps)
    event.dataTransfer.setData('text', stringifiedParameters)
  }

  return {
    draggable: true,
    onDragStart,
  }
}

interface ShareListItemDragProps {
  disabled?: boolean
  shareId: string
}

const DragWrapper = styled.div`
  -webkit-touch-callout: none;
`

const ShareListItemDrag: React.FC<ShareListItemDragProps> = props => {
  const { children, disabled = false, shareId } = props
  const dragAndDropProps = useShareListItemDrag<HTMLDivElement>(
    disabled,
    shareId
  )

  return <DragWrapper {...dragAndDropProps}>{children}</DragWrapper>
}

export default ShareListItemDrag
